import { Franchise } from "../models/Franchise";
import { getApi } from "./Api";


export const getAllFranchises = async () => {
    try{
        return await getApi<Franchise[]>('franchises')
    }
    catch(error){
        throw error;
    }
}